import { ENDPOINTS, sendPostRequest } from '.'

interface submitContactFormProps {
  lang: string
  name: string
  email: string
  profession: string
  institution: string
  phone: string
}

export const submitContactForm = async (formData: submitContactFormProps) => {
  try {
    return await sendPostRequest(
      ENDPOINTS.contact_email,
      {
        ...formData,
        origin: 'Bioatlas'
      },
      {
        'x-api-key': process.env.CONTACT_EMAIL_API_KEY
      }
    )
  } catch (e) {
    throw e
  }
}
